import { render, staticRenderFns } from "./DtcEventItem.vue?vue&type=template&id=500c188f"
import script from "./DtcEventItem.vue?vue&type=script&lang=js"
export * from "./DtcEventItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports